import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { useMemo } from 'react';

import { addImageParams } from '@/utils/urls';

type Props = {
    imageUrl: string;
    label: string;
    url: string;
};

export const ImageTile = ({ imageUrl, label, url }: Props) => {
    const optimizedImageUrl = useMemo(() => addImageParams({ height: 42, url: imageUrl }), [imageUrl]);

    return (
        <a
            className="flex cursor-pointer border border-border-secondary text-text-primary no-underline hover:bg-background-hover hover:no-underline [&:hover_span]:text-primary-400"
            href={url}
        >
            <span className="relative max-h-[42px] min-h-[42px] max-w-[43px] min-w-[43px] overflow-hidden border-r border-border-secondary bg-border-secondary">
                <img
                    alt={label}
                    className="h-full w-full rounded-l-[2px] object-cover"
                    loading="lazy"
                    src={optimizedImageUrl}
                />
            </span>
            <BodySecondary className="text-inherit flex items-center justify-center p-xs whitespace-nowrap">
                {label}
            </BodySecondary>
        </a>
    );
};
